import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { Button, Form, Modal } from 'react-bootstrap';

function GDSNSubscriptionModal({ show, onHide, manufacturer, onSubscribe }) {
  const [selectedGln, setSelectedGln] = useState('');

  const glnOptions = manufacturer?.manufacturer_glns
    ? Object.entries(manufacturer.manufacturer_glns).map(([gln, subCompanyName]) => ({
        gln,
        displayName: subCompanyName ? `${subCompanyName} - ${gln}` : `${gln}`,
      }))
    : [];

  const handleSubmit = () => {
    if (selectedGln) {
      onSubscribe(selectedGln);
      onHide();
    }
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>Subscribe to GDSN Service</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>Select the GLN you want to use for the GDSN subscription:</p>
        <Form>
          <Form.Group>
            {glnOptions.length > 0 ? (
              glnOptions.map((option, index) => (
                <Form.Check
                  key={index}
                  type="radio"
                  id={`gln-option-${index}`}
                  label={option.displayName}
                  value={option.gln}
                  name="glnOptions"
                  checked={selectedGln === option.gln}
                  onChange={() => setSelectedGln(option.gln)}
                />
              ))
            ) : (
              <p>No GLNs available for this manufacturer</p>
            )}
            {!selectedGln && <div className="text-danger mt-2">Please select a GLN</div>}
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Cancel
        </Button>
        <Button variant="primary" onClick={handleSubmit} disabled={!selectedGln}>
          Subscribe
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

GDSNSubscriptionModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  manufacturer: PropTypes.object,
  onSubscribe: PropTypes.func.isRequired,
};

export default GDSNSubscriptionModal;
